import { Component, computed, input } from '@angular/core';
import { CardComponent } from '../../../../components/card/card.component';
import { AnalyticsCardInfoComponent } from '../analytics-card-info/analytics-card-info.component';
import { LinkComponent } from '../../../../components/link/link.component';
import { TableComponent } from '../../../../components/table/table.component';
import { VisitorsGraphComponent } from './visitors-graph/visitors-graph.component';
import { GraphGeoComponent } from '../../../../components/graph-geo/graph-geo.component';
import { VisitorsData } from '@shared/interfaces/analytics';
import { environment } from '../../../../../environments/environment';

interface VisitorsByDateTable {
  labels: { date: string; visitors: string };
  data: { date: string; visitors: number }[];
}
interface VisitorsByCountryTable {
  labels: { country: string; visitors: string };
  data: { country: string; visitors: number }[];
}
@Component({
  selector: 'app-analytics-visitors',
  imports: [
    CardComponent,
    AnalyticsCardInfoComponent,
    LinkComponent,
    TableComponent,
    VisitorsGraphComponent,
    GraphGeoComponent,
  ],
  templateUrl: './analytics-visitors.component.html',
  styleUrl: './analytics-visitors.component.css',
})
export class AnalyticsVisitorsComponent {
  public period = input<string>();
  public data = input<VisitorsData>();
  protected analyticsLink = environment.analytics.link;
  protected visitorsByDateTable = computed<VisitorsByDateTable>(() => {
    const byDate = this.data()?.byDate || {};
    return {
      labels: { date: 'Date', visitors: 'Visitors' },
      data: Object.entries(byDate).map(([date, visitors]) => ({ date, visitors })),
    };
  });
  protected visitorsByCountryTable = computed<VisitorsByCountryTable>(() => {
    const byCountry = this.data()?.byCountry || {};
    return {
      labels: { country: 'Country', visitors: 'Visitors' },
      data: Object.entries(byCountry).map(([country, visitors]) => ({ country, visitors })),
    };
  });
  protected totalVisitors = computed(() => {
    const byDate = this.data()?.byDate || {};
    return Object.values(byDate).reduce((acc, visitors) => acc + visitors, 0);
  });
}
